export const SORT_TYPE = {
    CLOSE : 0,
    MANY : 1,
    REIVEW_GOOD : 2
}

export const INSTA_POPUP_TYPE = {
    METHOD: 'method',
    CONFIRM: 'confirm',
    SUCCESS: 'success'
}

export const WEATHER_CODE_LABEL = {
    0: '맑음',
    1: '대체로 맑음',
    2: '부분 흐림',
    3: '흐림',
    45: '안개',
    48: '안개',
    51: '이슬비(약함)',
    53: '이슬비(보통)',
    55: '이슬비(강함)',
    61: '비(약함)',
    63: '비(보통)',
    65: '비(강함)',
    66: '어는 비(약함)',
    67: '어는 비(강함)',
    71: '눈(약함)',
    73: '눈(보통)',
    75: '눈(강함)',
    77: '진눈깨비',
    80: '소나기(약함)',
    81: '소나기(보통)',
    82: '소나기(강함)',
    85: '눈 소나기(약함)',
    86: '눈 소나기(강함)',
    95: '뇌우',
    96: '뇌우(우박)',
    99: '뇌우(강한 우박)',
};

export const TRIGGER_TYPE = {
    // ---- 일반회원 ----
    // 복귀 유저
    RETURNING_USER: 0,
    // 신규 가입
    NEW_SIGNUP: 1,
    //신규 가입 - 순서대로 훈련시작하기, 입단 요청서 작성하기, 포지션 찾기 프로, 축구팀 찾기
    NEW_SIGNUP_TRAINING: 1000,
    NEW_SIGNUP_REQUEST: 1001,
    NEW_SIGNUP_POSITION: 1002,
    NEW_SIGNUP_SOCCER: 1003,
    NEW_SIGNUP_CONSISTENCY: 1004,

    // 업로드 직후 (피드백 유도)
    AFTER_UPLOAD_FEEDBACK: 2,
    // 루틴 마스터 (주 3회 이상)
    ROUTINE_MASTER: 3,
    // 작심삼일 탈출 / 루틴 형성(주간 업로드 1~2회)
    ROUTINE_FORMATION: 4,
    // [눈팅 탈출] 영상 부족 & 시청만 함(시청 3회↑ or 체류↑ & 업로드 X)
    LURKING_ESCAPE: 5,
    // 입단신청 시도 (미인증)(엘리트/비선출 통합)
    JOIN_APPLY_ATTEMPT_UNVERIFIED: 6,
    // 이적시장 체류 (관심)(팀 상세조회 다수 or 체류시간↑)
    TRANSFER_MARKET_STAY: 7,
    // 입단요청서 작성 중 이탈
    JOIN_FORM_LEAVE: 8,
    // 입단요청서 작성 완료 (대기 중)
    JOIN_FORM_COMPLETE_PENDING: 9,
    // 입단 매칭 안 됨
    JOIN_MATCH_FAILED: 10,
    // 전문가 피드백 도착
    EXPERT_FEEDBACK_ARRIVED: 11,
    // 스카우트 제안 도착
    SCOUT_OFFER_ARRIVED: 12,

    // ---- 전문가 회원 ----
    // 전문가 가입 승인 직후
    EXPERT_APPROVAL_AFTER: 13,
    // 전문가 가입 승인 직후 - 멤버쉽, 피드백 작성하기, 전문가 인증, 팀 등록
    EXPERT_APPROVAL_AFTER_MEMBERSHIP: 1300,
    EXPERT_APPROVAL_AFTER_FEEDBACK: 1301,
    EXPERT_APPROVAL_AFTER_AUTH: 1302,
    EXPERT_APPROVAL_AFTER_REGIST: 1303,

    // 장기 미접속
    LONG_INACTIVITY: 14,
    // 인재 탐색 중(선수 프로필 다수 열람)
    TALENT_SEARCH: 15,
    // 인기 급상승 선수(조회수/좋아요 급증)
    POPULAR_PLAYER_SURGE: 16,
    // 입단 신청 도착(선수가 먼저 지원)
    JOIN_APPLICATION_ARRIVED: 17,
    // 관심 선수의 역제안 (내가 찜한 선수가 입단 / 테스트 희망 시)
    INTERESTED_PLAYER_COUNTER_OFFER: 18,
    // 피드백 답변 작성 중 이탈
    FEEDBACK_RESPONSE_LEAVE: 19,
    // 그라운드 훈련 영상 시청 후
    GROUND_TRAINING_VIDEO_AFTER: 20,
    // 전문가 미인증
    EXPERT_UNVERIFIED: 21,
    // 포인트 부족(조회 시도시 잔액 <비용)
    INSUFFICIENT_POINTS: 22,
    // 조회 후 관심 미표시 (포인트 소진됨)
    NO_INTEREST_AFTER_VIEW: 23,
    // 감독 팀 등록
    EXPERT_TEAM_REGIST: 24,
    //회원에게 새 피드백 도착
    FEEDBACK_ARRIVED_TO_USER: 25,
}

export const MISSION_TYPE = {
    INVITE_FRIENDS: '친구 초대하기',
    UPLOAD_TRAINING_VIDEO: '훈련 영상 업로드',
    REPLY: '댓글 미션',
}

export const TEAM_TYPE = {
    PRO_SOCCER_TEAM: '프로 축구팀',
    YOUTH_TEAM: '유스팀',
    CLASS_1_PRO_TEAM: '1종 전문축구팀',
    CLASS_2_TEAM: '2종 축구팀',
    CLUB_TEAM: '동호인 축구팀',
    PLANNED_TEAM: '창단 예정팀'
}

export const AFTER_POSITION_POPUP_TYPE = {
    SOCCER_LEARN: '축구배우기',
    SOCCER_JOIN: '축구팀입단',
    NOT_SAVE_COMMON: '미적용 일반회원',
    NOT_SAVE_BE_SOCCER_PLAYER: '미적용 선수희망'
}

export const SCROLL_DIRECTION = {
    TOP: 'TOP',
    LEFT: 'LEFT'
}

export const POSITION_TYPE = {
    LITE: 'lite',
    PRO: 'pro'
}

export const NOTICE_HIIDEN_BTN_SHOW = {
    HIDDEN: '0',
    SHOW: '1'
}

export const NOTICE_LOCATION = {
    LEARN_SOCCER: '축구 배우기',
    JOIN_SOCCER_TEAM: '축구팀 입단'
}

export const POLL_TYPE = {
    TEXT: '텍스트',
    IMAGE: '이미지'
}

export const NOTICE_TYPE = {
    NOTICE: '공지사항',
    EVENT: '이벤트'
}

export const FEEDBACK_MODE = {
    VIEW: 'view',
    WRITE: 'write'
}


export const REVIEW_PAGE_TYPE = {
    SENT: '보낸 후기',
    RECEVIED: '받은 후기'
}

export const MEMBER_TALK_BOX_TYPE = {
    MERCENARY: '용병',
    MEMBER_TALK: '멤버톡'
}

export const MAIN_TYPE = {
    SOCCER_TEAM_JOINING: '축구팀입단',
    SOCCER_LEARN: '축구배우기'
}

export const GROUP_IDX = {
    COURSE: 1,
    LESSON: 2,
    HOBBY: 3,
    ETC: 4
}

export const PAGE_NAME = {
    HOME: 'HOME',
    TRAINING: 'TRAINING',
    MEMBER_TALK: 'MEMBER_TALK',
    SOCCER_TEAM: 'SOCCER_TEAM'
}

export const REGIST_STEP = {
    REGIST_TYPE: "REGIST_TYPE",
    PHONE: "PHONE",
    AUTH_NUMBER: "AUTH_NUMBER",
    NAME: "NAME",
    BIRTHDAY: "BIRTHDAY",
    SEX: "SEX",
    REGION: "REGION",
    RECOMMEND_CODE: 'RECOMMEND_CODE',
    PURPOSE: "PURPOSE",
    SKILL: "SKILL",
    EXPERT_INFO: "EXPERT_INFO",
}

export const POPUP_TYPE = {
    REJECT: 'reject',
    CHAT_OPEN: 'chat_open'
}

export const WRITE_TYPE = {
    REVIEW: "REVIEW",
    HISTORY: "HISTORY"
}

export const ENJOY_TYPE = {
    ANYBODY: 'anybody',
    PRIVATE: 'private'
}

export const IS_LIKE = {
    LIKE: 1,
    UNLIKE: 0
}

export const IS_COACH = {
    COACH: '1',
    USER: '0'
}

export const CLASS_TYPE = {
    PERSONAL_CLASS: '개인수업',
    GROUP_CLASS: '단체수업',
    NOW: '나우스케줄'
}

export const CUR_SUB_TAB_TYPE = {
    POPULAR: 0,
    REALTIME: 1,
}

export const JOIN_SCHEDULE_TYPE = {
    JOIN_SCHEDULE : 0,
    LESSON_SCHEDULE : 2,
}

export const PROFILE_BOX_LIST = {
    POSITION: 'position',
    AGE_RANGE: 'age_range',
    SEX: 'sex',
    HEIGHT: 'height',
    FOOT_WAY: 'foot_way',
    SPECIAL_SKILL:'special_skill',
    PLAY_STYLE: 'playstyle',
    VISIT_REASONS: 'visit_reason',
    USE_REASONS: 'use_reasons',
    PLACE_NAME: 'place_name',
    CAREER: 'career',
    LICENSE: 'licenses',
    EXPERT_INFO: 'coach_type'
}

// 취미 계정: LEARN_SOCCER
// 선수 희망 계정: JOIN_SOCCER_TEAM
export const VISIT_REASON_TYPE = {
    JOIN_SOCCER_TEAM: '축구팀 입단 계정',
    LEARN_SOCCER: '축구 배우기/용병 구하기 계정'
}

// 취미 계정은 LESSON_LIST + HOBBY_LIST 중에 하나를 선택한 사용자 VISIT_REASON_TYPE.LEARN_SOCCER
export const HOBBY_LIST = [
    { title: '🏃🏻 경기 뛰기', id: '경기 뛰기', group_idx: GROUP_IDX.HOBBY },
    { title: '🕵️‍♂️ 용병 찾기', id: '용병 찾기', group_idx: GROUP_IDX.HOBBY },
    { title: '👬 멤버 모집하기', id: '멤버 모집하기', group_idx: GROUP_IDX.HOBBY },
    { title: '🏟️ 축구팀 찾기', id: '축구팀 찾기', group_idx: GROUP_IDX.HOBBY },
]

export const LESSON_LIST = [
    { title: '🥅 개인훈련', id: '개인훈련', group_idx: GROUP_IDX.LESSON },
    { title: '👬🏻 단체훈련', id: '단체훈련', group_idx: GROUP_IDX.LESSON },
]

// 선수 희망 계정은 COURSE_LIST 중에 하나를 선택한 사용자 VISIT_REASON_TYPE.JOIN_SOCCER_TEAM
export const COURSE_LIST = [
    { title: '🏆 축구선수 희망', id: '축구선수 희망', group_idx: GROUP_IDX.COURSE },
    { title: '🤔 축구 진로 상담', id: '축구 진로 상담', group_idx: GROUP_IDX.COURSE },
    { title: '🏟️ 축구팀 입단', id: '축구팀 입단', group_idx: GROUP_IDX.COURSE },
    { title: '🏃🏼현) 엘리트 선수', id: '현) 엘리트 선수', group_idx: GROUP_IDX.COURSE },
    { title: '🏃🏼전) 엘리트 선수', id: '전) 엘리트 선수', group_idx: GROUP_IDX.COURSE },
]

export const JOIN_WAY = {
    ANYBODY: '0',
    APPROVE: '1'
}

export const SOCCER_JOIN_SCHEDULE = {
    JOIN : 'join',
    SCHEDULE : 'schedule',
    MERCENARY_SCHEDULE : 'mercenary_schedule',
    MERCENARY_SCHEDULE_FROM_JOIN_SCHEDULE : 'mercenary_schedule_from_join_schedule',
    MY: 'my',
    MODIFY : 'modify',
}

export const SOCCER_HOW_TYPE = {
    ALL : '',
    COACH : 'coach',
    SOCCERHOW : 'soccerhow',
    NEWS : 'news',
    FREEBOARD : 'freeboard',
    REPLY : 'reply',
    QUESTION : 'question',
    ANSWER : 'answer',
    COMMUNITY : 'community',
    NOTICE : 'notice',
    MY_SOCCERHOW : 'my_soccerhow',
    NICNAME: 'nicname',
    REGION : 'region',
    SCHEDULE : 'schedule',
    SINGLE_TRAINING : 's_training',
    GROUP_TRAINING : 'g_training',
    SC_COUNSEL : 'sc_counsel',
    SC_JOIN : 'sc_join',
    SC_JOB : 'sc_job',
    FEEDBACK : 'feedback',
}

export const TOAST_TYPE = {
    AMEND : require('@/assets/img/toast_amend.png'),
    HEART : require('@/assets/img/toast_heart.png'),
    FAST : require('@/assets/img/toast_answer.png'),
    EMIT : require('@/assets/img/toast_emit.png'),
    DELETE : '',
    ONLYMEMBER : require('@/assets/img/only_member.png'),
    MAKESCHEDULE : require('@/assets/img/make_schedule.png'),
    CHECK : require('@/assets/img/check.png')
}

export const FORM_MODE = {
    INSERT : 'insert',
    UPDATE : 'update',
    DELETE : 'delete',
}

export const JOIN_CHAT_TYPE = {
    GROUP : 0,
    SINGLE : 3, //안쓰지만 import 떄매 남겨둠
    MERCENARY_REQUEST : 1,
    MERCENARY_PROPOSE : 2,
    OPEN : 4,
    CHAT_WITH_COACH : 5,
    CHAT_FOR_COACH_CERT : 6,
}

export const FIND_POSITION_PRO_TITLE = {
    MAIN_FORCE : '주력',
    ADVENTURE : '모험심',
    CONFIDENCE : '자신감',
    THOUGHTFUL : '배려심',
    HEALTH : '체력',
    BALL_CONTROL : '공제어감각',
    PASS_KICK_SHOOT : '패스킥슛',
    EYESIGHT : '시야',
    GAME_FLOW : '경기흐름',
    RESPONSIBILITY: '책임감',
    HEIGHT : '키',
    FOOT_WAY : '사용하는발'
}

export const JOIN_CHAT_HISTORY_TYPE = {
    NORMAL : 0,
    JOIN_DETAIL : 1,
    PROFILE : 2,
    JOIN_APPROVE : 3,
    IMAGE : 4,
    NOTICE : 5,
    MERCENARY_REFRESH_NORMAL : 6,
    MERCENARY_SCOUT_INFO : 7,
    MERCENARY_REQUEST_INFO : 8,
    MERCENARY_REQUEST_ACCEPT_INFO : 9,
    MERCENARY_PROPOSE_ACCEPT_INFO : 10,
    MERCENARY_SCHEDULE_CLOSE_INFO : 11,
    MERCENARY_EVALUATION : 12,
    MERCENARY_REQUEST_REJECT_INFO : 13,
    MERCENARY_PROPOSE_REJECT_INFO : 14,

    MEMBER_TALK_JOINED : 30,
    MEMBER_TALK_SETTING_CHANGED : 31,
    MEMBER_TALK_KICK_OUT : 32,
    MEMBER_TALK_NEW_NOTICE : 33,
    MEMBER_TALK_NEW_SQUAD : 34,
    MEMBER_TALK_NEW_SCHEDULE : 35,
    MEMBER_TALK_GET_OUT : 36,

    OPEN_SCHEDULE_INVITATION : 50,
    OPEN_SCHEDULE_SHARE : 51,

    ASK_TO_ADMIN_LOGO : 60,
    ASK_TO_ADMIN_INTRODUCE_FORM : 61,

    CHAT_FOR_COACH_CERT_LOGO : 70,
    CHAT_FOR_COACH_CERT_FORM : 71,

    RESERVE_TEST_DATE : 80,

    FEEDBACK_CONTENTS : 90,
}

export const VIEW_OPTION = {
    MY_LOCATION : 1,
    MY_ACTIVITY : 0
}

export const MY_VIEW_MODE = {
    ME : 0,
    OTHER : 1
}

export const MEMBER_TYPE = {
    USER : 0,
    COACH : 1,
    ADMIN : 2,
    NOLOGIN : 3
}


export const LOGIN_PLATFORM = {
    KAKAO : 0,
    APPLE : 1,
    SOCCERHOW : 2,
    NAVER : 3,
    GOOGLE : 4,
}


export const WEB_PLATFORM_TYPE = {
    ANDROID : 0,
    IOS : 1,
    OTHER : 9999
}

export const REPORT_TYPE_IDX = {
    SOCCERHOW_ANYONE : 0,
    SOCCERHOW_COACH : 1,
    JOIN_COMMUNITY : 2,
    JOIN_SCHEDULE : 3,
    PROFILE : 4,
    SCHEDULE : 5,
    JOIN: 6,
    SOCCERHOW_REQUEST : 7,
    SOCCERHOW_TRAINING : 8,
    TEAM_TRAINING : 9,
}

export const REPORT_TYPE_NAME = [
    '사커하우 누구나 답변 게시물',
    '사커하우 코치 답변 게시물',
    '커뮤니티 게시물',
    '조인 스케줄',
    '프로필 신고',
    '스케줄 신고',
    '멤버톡 신고',
    '입단요청서',
    '일반게시물',
    '트레이닝',

]

export const PUSH_VIEW_TYPE = {
    ALL : 0,
    INFOMATION : 1,
    NOTICE : 2,
}

export const JOIN_MEMBER_STATE = {
    APPLIED : 0,
    APPROVED : 1,
    GETOUT : 2,
    REJECT : 3,
    APPLY_REJECT : 4,
}

export const PUSH_ACTION = {
    MY_LOCATION : '1',
    SOCCERHOW_MAIN : '2',
    SOCCERJOIN_MAIN : '3',
    MY_PAGE : '4',
    POSITION_SEARCH : '5',
    ONE_ON_ON_ASK : '6',
    WEB_LINK : '7',
    NOTICE_DETAIL : '8',
    BRANCH_DETAIL : '9',
    COACH_DETAIL : '10',
    LADING_PAGE : '11',
    POSITION_PRO : '12',
    MAKE_JOIN : '13',
    MERCENARY_SETTING : '14',
    MERCENARY : '15',
    SELECT_POSITION_FIND : '16',
    MAKE_MERCENARY_SCHEDULE : '17',
    SOCCERHOW_TAB_SOCCERHOW : '18',
    NOTICE_EVENT_DETAIL : '19',
    HOME_LEARN : '20',
    HOME_JOIN : '21',
    TRAINING_MAIN : '22',
    MYCHAT : '23',
    MESSAGE : '24',
    CHATTING : '30',
    SPORTLIGHT_LIST : '31',
    SPORTLIGHT_DETAIL : '32',
    TEAM_DETAIL : '33',
    HOME : '34',

    SOCCERHOW_DETAIL : '1000',
    COMMUNITY_DETAIL : '1001',
    JOIN_DETAIL : '1002',
    JOIN_SCHEDULE_DETAIL : '1003',
    JOIN_TALK : '1004',
    COMMUNITY_MAIN : '1005',
    MEMBER_EVALUATION : '1006',
    MEMBER_EVALUATION_RESULT : '1007',
    PROFILE : '1008',
    REPORT_DETAIL : '1009',
    MERCENARY_SCHEDULE_DETAIL : '1010',
    JOIN_INVITATION_LIST : '1011',

    OPEN_SCHEDULE_DETAIL : '1012',
    LESSON_SCHEDULE_DETAIL : '1013',
    OPEN_TALK : '1014',
    POSITION_DELAY : '1015',
    WEB_NOWPAGE : '1016',

    SOCCERHOW_REQUEST_DETAIL : '1020',
    SOCCERHOW_TRAINING_DETAIL : '1021',
    DIRECT_MESSAGE_LIST : '1022',
    ACTIVITY_RANKING : '1023',
    POLL_DETAIL : '1024',

    MERCENARY_REQUEST_RECEIVED : '1101',
    MERCENARY_PROPOSE_RECEIVED : '1102',
    MERCENARY_REQUEST_STATUS_CHANGED : '1103',
    MERCENARY_PROPOSE_STATUS_CHANGED : '1104',

    MERCENARY_SCHEDULE_MINE : '1105',
    
    LEARN_TOP_BANNER_DETAIL : '1200'
}

export const JOIN_STATE = {
    OPEN : 0,
    LOCK : 1,
    CLOSE : 2,
    CANCEL : 3,
}

export const FEED_VIEW_TYPE = {
    MEMBER_TALK: 'membertalk',
    SCHEDULE: 'schedule',
    SOCCERHOW: 'soccerhow',
    LESSON: 'lesson'
}

export const PROFILE_FOOT_WAY = {
    BOTH : 0,
    LEFT : 1,
    RIGHT : 2,
}

export const MY_MONEY_TYPE = {
    ALL : 'all',
    PLUS : 'plus',
    MINUS: 'minus'
}

export const INNOPAY_MODE = {
    DIRECT_PAY : 0,
    REGISTERED_CARD_PAY : 1
}

export const MODAL_MODE = {
    DONG: 'DONG',
    CURRENT_LOC: 'CURRENT_LOC'
}


export const DUES_TYPE = {
    DEFAULT : 0,
    JOIN_PAY : 1,
    SCOUT_PAY : 2,
    FREE : 3
}

export const JOIN_SCHEDULE_INTRODUCE_TYPE = {
    TITLE : 0,
    IMAGE : 1,
    TEXT : 2,
}

export const CARD_CODE_NAME = {
    '01' : '비씨',
    '02' : '국민',
    '03' : '외환',
    '04' : '삼성',
    '06' : '신한',
    '07' : '현대',
    '08' : '롯데',
    '09' : '한미',
    '10' : '신세계한미',
    '11' : '시티',
    '12' : '농협',
    '13' : '수협',
    '14' : '평화',
    '15' : '우리',
    '16' : '하나',
    '17' : '동남(주택)',
    '18' : '주택',
    '19' : '조흥(강원)',
    '20' : '축협(농협)',
    '21' : '광주',
    '22' : '전북',
    '23' : '제주',
    '24' : '산은',
    '25' : '해외비자',
    '26' : '해외마스터',
    '27' : '해외다이너스',
    '28' : '해외AMX',
    '29' : '해외JCB',
}

export const DIRECT_MESSAGE_TYPE = {
    // 회원이 코치에게 보낸 입단 요청서
    REQUEST_TO_COACH : 0,
    // 스카우트 제의
    COACH_TO_REQUEST : 1,
    COACH_TO_TRAINING : 2,
    // 코치가 회원에게 보낸 다이렉트 메시지
    COACH_TO_USER : 3,
    FEEDBACK: 4
}

export const REAL_TIME_NEWS_TYPE = {
    SCOUT : 0,
    INTEREST : 1,
}

export const DIRECT_MESSAGE_STATUS = {
    PARENT_PAY_WAITING : -1,
    REQUEST_SEND : 0,
    COACH_CHECKED : 1,
    COACH_ACCEPED : 2,
    // 테스트 일정 잡기
    RESERVE_TEST_DATE : 3,
    // 입단 테스트 진행
    PROGRESSING_TEST : 4,
    // 결과 안내
    ANNOUNCE_RESULT : 5,
}

export const SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN = {
    DEFAULT : 0,
    FROM_REQUEST_JOIN_TEAM_SELECTOR : 1,
}


let open_chat_regions_temp = [];

if (process.env.NODE_ENV === 'development'){
    open_chat_regions_temp = [
        { region: '서울', imgPath: require('@/assets/nationwide_img/서울.png'), chat_idx : 2315 },
        { region: '부산', imgPath: require('@/assets/nationwide_img/부산.png'), chat_idx : 2316 },
        { region: '인천', imgPath: require('@/assets/nationwide_img/인천.png'), chat_idx : 2317 },
        { region: '대구', imgPath: require('@/assets/nationwide_img/대구.png'), chat_idx : 2318 },
        { region: '대전', imgPath: require('@/assets/nationwide_img/대전.png'), chat_idx : 2319 },
        { region: '광주', imgPath: require('@/assets/nationwide_img/광주.png'), chat_idx : 2320 },
        { region: '울산', imgPath: require('@/assets/nationwide_img/울산.png'), chat_idx : 2321 },
        { region: '세종', imgPath: require('@/assets/nationwide_img/세종.png'), chat_idx : 2322 },
        { region: '경기도', imgPath: require('@/assets/nationwide_img/경기도.png'), chat_idx : 2323 },
        { region: '충북', imgPath: require('@/assets/nationwide_img/충북.png'), chat_idx : 2324 },
        { region: '충남', imgPath: require('@/assets/nationwide_img/충남.png'), chat_idx : 2325 },
        { region: '전남', imgPath: require('@/assets/nationwide_img/전남.png'), chat_idx : 2326 },
        { region: '경북', imgPath: require('@/assets/nationwide_img/경북.png'), chat_idx : 2327 },
        { region: '전북', imgPath: require('@/assets/nationwide_img/전북도.png'), chat_idx : 2329 },
        { region: '강원도', imgPath: require('@/assets/nationwide_img/강원도.png'), chat_idx : 2330 },
        { region: '제주도', imgPath: require('@/assets/nationwide_img/제주도.png'), chat_idx : 2331 },
    ];
} else {
    open_chat_regions_temp = [
        { region: '서울', imgPath: require('@/assets/nationwide_img/서울.png'), chat_idx : 5380 },
        { region: '부산', imgPath: require('@/assets/nationwide_img/부산.png'), chat_idx : 5381 },
        { region: '인천', imgPath: require('@/assets/nationwide_img/인천.png'), chat_idx : 5382 },
        { region: '대구', imgPath: require('@/assets/nationwide_img/대구.png'), chat_idx : 5383 },
        { region: '대전', imgPath: require('@/assets/nationwide_img/대전.png'), chat_idx : 5384 },
        { region: '광주', imgPath: require('@/assets/nationwide_img/광주.png'), chat_idx : 5385 },
        { region: '울산', imgPath: require('@/assets/nationwide_img/울산.png'), chat_idx : 5386 },
        { region: '세종', imgPath: require('@/assets/nationwide_img/세종.png'), chat_idx : 5387 },
        { region: '경기도', imgPath: require('@/assets/nationwide_img/경기도.png'), chat_idx : 5388 },
        { region: '충북', imgPath: require('@/assets/nationwide_img/충북.png'), chat_idx : 5389 },
        { region: '충남', imgPath: require('@/assets/nationwide_img/충남.png'), chat_idx : 5390 },
        { region: '전남', imgPath: require('@/assets/nationwide_img/전남.png'), chat_idx : 5391 },
        { region: '경북', imgPath: require('@/assets/nationwide_img/경북.png'), chat_idx : 5392 },
        { region: '전북', imgPath: require('@/assets/nationwide_img/전북도.png'), chat_idx : 5394 },
        { region: '강원도', imgPath: require('@/assets/nationwide_img/강원도.png'), chat_idx : 5395 },
        { region: '제주도', imgPath: require('@/assets/nationwide_img/제주도.png'), chat_idx : 5396 },
    ];
}

export const POINT_HISTORY_TYPE = {
    PROFILE_FIRST_SETTING : 0,
    POSITION_FIND : 1,
    REPLY_TO_FRIEND : 2,
    FRIEND_INVITATION : 3,
    TRAINING_UPLOAD : 4,
    MONTHLY_TRAINING_UPLOAD : 5,
    APP_START : 6,
}

export const POINT_HISTORY_REWARD = {
    PROFILE_FIRST_SETTING : 10,
    POSITION_FIND_ : 10,
    REPLY_TO_FRIEND : 3,
    FRIEND_INVITATION : 5,
    TRAINING_UPLOAD : 4,
    MONTHLY_TRAINING_UPLOAD : 30,
    APP_START : 5,
}

export const SCOUT_POPUP_TYPE = {
    SEND_REQUEST : 0,
}

export const MEMBER_CAREER_HISTORY_STATE = {
    REQUEST : 0,
    APPROVED : 1,
    MODIFICATION_REQUEST : 2,
    REJECT : 3
}

export const PARENT_PAY_TYPE = {
    REQUEST : 0,
    SOCCERHOW_SECRET_REQUEST : 1,
}

export const MEMBER_INSTARGRAM_EVENT_STATE = {
    WAITING : 0,
    CERTIFIED : 1,
    REJECTED : 2,
}

export const MEMBER_POPUP_TYPE = {
    INSTARGRAM_CERTIFIED : 10,
    INSTARGRAM_REJECTED : 11,
    SOCCERHOW_DELETE_WITH_REASON : 20,
    EXTINCTION : 30,
}

export const OPEN_CHAT_REGIONS = open_chat_regions_temp;



export const HOME_POPUP_TODAY_CLOSE_DATE = 'HOME_POPUP_TODAY_CLOSE_DATE';
export const FORCE_SOCCER_HOW_LAST_DATE = 'FORCE_SOCCER_HOW_LAST_DATE';
export const ASK_URL = "https://soccerhow.channel.io";
export const TEST_SERVER_HOST_NAME = 'obyungear-user-test.ubiplus.co.kr';
export const initialRouteStr = '/view/home';
export const MATCH_REPEAT_SCHEDULE_IDX = 59;


let direct_message_price = 9900;
if (process.env.NODE_ENV === 'development'){
    direct_message_price = 11;
}

let secret_request_price = 29000;
if (process.env.NODE_ENV === 'development'){
    secret_request_price = 1000;
}


export const DIRECT_MESSAGE_REQUEST_PRICE = direct_message_price;
export const SOCCERHOW_SECRET_REQUEST_PRICE = secret_request_price;